import React from 'react';
import { Link } from 'react-router-dom';
import './PublicShell.css';
import { PRODUCT_NAME, TAGLINE } from '../../config/appBranding';

/**
 * Thin layout for unauthenticated marketing and trust pages. Kept deliberately
 * minimal for W0 — W1 replaces the landing body and W4 pulls chrome through
 * shared design tokens.
 */
export default function PublicShell({ children, hideFooter = false }) {
  return (
    <div className="public-shell">
      <header className="public-shell__header">
        <Link to="/" className="public-shell__brand">
          {PRODUCT_NAME}
        </Link>
        <nav className="public-shell__nav" aria-label="Public">
          <Link to="/demo">Book a Demo</Link>
          <Link to="/login" className="public-shell__nav-cta">Sign in</Link>
        </nav>
      </header>
      <main className="public-shell__main">{children}</main>
      {!hideFooter && (
        <footer className="public-shell__footer">
          <div className="public-shell__footer-links">
            <Link to="/privacy">Privacy</Link>
            <Link to="/security">Security</Link>
            <Link to="/terms">Terms</Link>
            <Link to="/support">Support</Link>
            <Link to="/status">Status</Link>
            <a href="mailto:sales@vizionops.com">Contact Sales</a>
            <a href="mailto:hello@vizionops.com">Contact</a>
          </div>
          <div className="public-shell__footer-meta">
            &copy; {new Date().getFullYear()} {PRODUCT_NAME} · {TAGLINE}
          </div>
        </footer>
      )}
    </div>
  );
}
